const leg = require('./leg_prototype');

function mytripsLeg(legData) {
    const mytripsLeg = Object.create(leg(legData));

    mytripsLeg._legPath = 'section';
    mytripsLeg._originPath = `${mytripsLeg._legPath}.from`;
    mytripsLeg._destinationPath = `${mytripsLeg._legPath}.to`;

    return mytripsLeg;
}

module.exports = mytripsLeg;
